export default {
  ADMIN_DUP_USERNAME: '이미 존재하는 사용자 이름입니다', // 该用户名已经存在
  DOB_IS_BEFORE_TODAY: '생년월일은 현재 날짜 이전이어야 합니다', // 出生日期必须在当前日期之前
  BANK_CARD_DUP_NUMBER: '이미 존재하는 은행 카드 번호입니다', // 该银行卡卡号已经存在
  PERMISSION_DENY_ADMIN_ONLY: '시스템 관리자만이 이 작업을 수행할 수 있습니다', // 只有系统管理员才可以执行该操作
  PERMISSION_DENY_ADMIN_OR_IT_ONLY: '시스템 관리자 또는 기관 관리자만이 이 작업을 수행할 수 있습니다', // 只有系统管理员或者机构管理员才可以执行该操作
  // 5.1 基础相关
  INVALID_ARGUMENT_BAD_AGENT: '계정 정보가 잘못되었습니다 [0010]', // 账户信息错误[0010]
  INVALID_ARGUMENT_MIN_DEPOSIT: '최소 입금 한도를 초과해야 합니다: {minDeposit} 달러(또는 해당 통화 금액)', // 必须超过最小充值限额：{minDeposit}美元（或等值货币金额）
  INVALID_ARGUMENT_MAX_DEPOSIT: '최대 입금 한도를 초과할 수 없습니다: {maxDeposit} 달러(또는 해당 통화 금액)', // 不能超过最大充值限额：{maxDeposit}美元（或等值货币金额）
  INVALID_ARGUMENT_MIN_WITHDRAWAL: '최소 인출 한도를 초과해야 합니다: {minWithdrawal} 달러(또는 해당 통화 금액)', // 必须超过最小取款限额：{minWithdrawal}美元（或等值货币金额）
  INVALID_ARGUMENT_MAX_WITHDRAWAL: '최대 인출 한도를 초과할 수 없습니다: {maxWithdrawal} 달러(또는 해당 통화 금액)', // 不能超过最大取款限额：{maxWithdrawal}美元（或等值货币金额）
  INVALID_ARGUMENT_MORE_THAN_2_SCALES: '소수점 자리는 2자리를 초과할 수 없습니다', // 小数位不能超过两位
  INVALID_ARGUMENT_RESOURCE_SAVE: '자원 저장 매개 변수 오류', // 资源保存参数错误
  INVALID_ARGUMENT_NULL_PASSWORD: '비밀번호를 입력해 주십시오', // 密码不能为空
  INVALID_ARGUMENT_CONFIRM_PASSWORD: '비밀번호가 일치하지 않습니다', // 确认密码不匹配
  INVALID_ARGUMENT_FORMAT_PASSWORD: '최소한 1개의 대문자, 1개의 소문자, 1개의 숫자를 포함하고 8~32자의 길이여야 합니다', // 必须至少包含：一个大写字母、一个小写字母、一个数字，并且密码长度为8~32位字符
  INVALID_ARGUMENT_PASSWORD_VER_MISMATCH: '비밀번호 버전이 일치하지 않습니다', // 密码版本不匹配
  INVALID_ARGUMENT_MISSING_PASSWORD_VER_CLAIM: '비밀번호 버전 선언이 누락되었습니다', // 缺少密码版本声明
  INVALID_ARGUMENT_CAN_NOT_DELETE_FOR_VERIFIED: '인증된 데이터는 삭제할 수 없습니다', // 已认证数据不能删除
  INVALID_ARGUMENT_ENTER_BANK_NUM: '은행 카드 번호를 입력해 주십시오', // 请输入银行卡号
  INVALID_ARGUMENT_IT_DUP_ID: '이 기관 ID는 이미 존재합니다', // 该机构ID已经存在
  INVALID_ARGUMENT_IT_DUP_APP_KEY: '이미 사용 중인 사용자 이름입니다. 사용자 이름을 변경하십시오', // 用户名已经被使用，请更换用户名
  INVALID_REGISTER: '등록이 금지되었습니다', // 禁止注册
  INVALID_DATA_USED_CANNOT_BE_DELETED: '사용된 데이터는 삭제할 수 없습니다', // 已使用的数据不能删除
  INVALID_ARGUMENT_CONFIG_BANK_NOT_NULL: 'BANK 정보는 비워둘 수 없습니다. BANK 정보를 추가하려면 은행 카드 관리 페이지로 이동하세요.',
  // 5.2 货币相关
  INVALID_ARGUMENT_CURRENCY_BASE_QUOTE_CAN_NOT_BE_THE_SAME: '두 통화는 동일할 수 없습니다', // 两个货币不能相同
  INVALID_ARGUMENT_FX_RATE_CAN_BE_NULL: '환율은 비워 둘 수 없습니다', // 汇率不能为空
  INVALID_ARGUMENT_FX_RATE_MUST_BE_POSITIVE: '환율은 0 또는 음수일 수 없습니다', // 汇率不能为零或者负数
  INVALID_ARGUMENT_CURRENCY_DUP_CURRENCY_PAIR: '동일한 화폐 쌍이 이미 존재합니다', // 相同的货币对已经存在
  INVALID_ARGUMENT_CURRENCY_AMOUNT_NOT_MATCH: '환율 변환 금액이 잘못되었습니다', // 汇率转化金额有误
  INVALID_ARGUMENT_CURRENCY_FX_RATE_NOT_FOUND: '해당 화폐 쌍에 대한 환율을 찾을 수 없습니다', // 未找到货币对所对应的汇率
  INVALID_ARGUMENT_CURRENCY_FX_RATE_TEMPLATE_NOT_FOUND: '환율 템플릿을 찾을 수 없습니다', // 未找到汇率模板
  INVALID_ARGUMENT_CURRENCY_INVALID_FOR_THIS_BANK: '현재 은행은 이 화폐를 지원하지 않습니다', // 当前银行不支持此货币
  INVALID_ARGUMENT_CURRENCY_INVALID_FOR_THIS_RECEIVE_METHOD: '현재 수령 방식은 이 화폐를 지원하지 않습니다', // 当前收款方式不支持此货币
  // 5.3 用户相关
  INVALID_ARGUMENT_LOGIN_AUTH_BY_GOOGLE: '이메일은 이미 GOOGLE에 의해 승인되었습니다, GOOGLE 승인으로 로그인해주세요',
  INVALID_ARGUMENT_LOGIN_AUTH_BY_FACEBOOK: '이메일은 이미 FACEBOOK에 의해 승인되었습니다, FACEBOOK 승인으로 로그인해주세요',
  INVALID_ARGUMENT_LOGIN_AUTH_BY_APPLE: '이메일은 이미 APPLE에 의해 승인되었습니다, APPLE 승인으로 로그인해주세요',
  INVALID_ARGUMENT_LOGIN_AUTH_BY_PASSWORD: '이메일은 비밀번호로 승인되었습니다, 비밀번호로 로그인해주세요',
  INVALID_ARGUMENT_CUSTOMER_FORMAT: '사용자 이름은 이메일 주소여야 합니다', // 用户名必须为邮箱地址
  INVALID_ARGUMENT_CUSTOMER_DUP_USERNAME: '사용자 이름이 이미 활성화되었습니다', // 用户名已激活
  INVALID_ARGUMENT_CUSTOMER_DUP_MOBILE: '이미 전화 번호가 존재합니다', // 手机号已存在
  INVALID_ARGUMENT_CUSTOMER_NOT_VERIFIED: '고객 정보가 인증되지 않았습니다', // 客户信息未认证
  INVALID_ARGUMENT_CUSTOMER_AUTH_NOT_EXIST: '고객 인증 정보가 존재하지 않습니다', // 客户认证信息不存在
  INVALID_ARGUMENT_CUSTOMER_NOT_EXIST: '고객 정보가 존재하지 않습니다', // 客户信息不存在
  INVALID_ARGUMENT_EMAIL_CODE_NOT_EXIST: '링크가 존재하지 않습니다', // 链接不存在
  INVALID_ARGUMENT_EMAIL_CODE_REPEAT: '링크가 이미 만료되었습니다', // 链接已经失效
  INVALID_ARGUMENT_EMAIL_CODE_TIMEOUT: '링크가 만료되었습니다', // 链接已经过期
  INVALID_ARGUMENT_CUSTOMER_ACCOUNT_NOT_ACTIVATED: '고객 거래 계정이 활성화되지 않았습니다', // 客户交易账号未激活
  CUSTOMER_VERIFY_FLOW_NOT_FOUND: '고객 검증 프로세스가 존재하지 않습니다', // 客户验证流程不存在
  CUSTOMER_WITHDRAWAL_FLOW_NOT_FOUND: '고객 출금 프로세스가 존재하지 않습니다', // 客户提现流程不存在
  INVALID_ARGUMENT_CUSTOMER_ID_EXPIRE_LIMIT: '신분 정보 만료일은 최소 {days}일을 남겨야 합니다', // 身份信息过期日必须至少剩余{days}天
  // 5.4 业务流程相关
  INVALID_ARGUMENT_UNABLE_TO_LOCK_WITHDRAWAL_AMOUNT: '금액을 잠그는 데 실패했습니다. 다시 시도하십시오', // 无法锁定额度，请刷新后再试
  INVALID_ARGUMENT_PROCESS_SUBMIT_ILLEGAL_STATUS: '상태가 이미 제출되었습니다', // 状态已经是提交
  INVALID_ARGUMENT_PROCESS_RETRACT_ILLEGAL_STATUS: '취소할 수 없습니다', // 不能被撤回
  INVALID_ARGUMENT_PROCESS_RETRACT_ILLEGAL_PROCESSED:
    '처리 상태 오류: 처리 상태가 미처리 상태 일 때만 철회 작업이 허용됩니다 (데이터가 이미 변경되었을 수 있으므로 데이터를 다시 검색한 후 다시 시도하십시오)', // 处理状态错误：处理状态为未处理时才允许撤回操作（数据可能已发生变化，请重新检索数据后再尝试）
  INVALID_ARGUMENT_PROCESS_APPROVAL_ILLEGAL_STATUS:
    '검토 상태 오류: 상태가 제출 상태 일 때만 반려 또는 승인 작업이 허용됩니다 (데이터가 이미 변경되었을 수 있으므로 데이터를 다시 검색한 후 다시 시도하십시오)', // 审核状态错误：审核状态为提交时才允许驳回或通过操作（数据可能已发生变化，请重新检索数据后再尝试）
  INVALID_ARGUMENT_PROCESS_APPROVAL_ILLEGAL_PROCESSED:
    '처리 상태 오류: 처리 상태가 미처리 상태 일 때만 반려 또는 승인 작업이 허용됩니다 (데이터가 이미 변경되었을 수 있으므로 데이터를 다시 검색한 후 다시 시도하십시오)', // 处理状态错误：处理状态为未处理时才允许驳回或通过操作（数据可能已发生变化，请重新检索数据后再尝试）
  INVALID_ARGUMENT_PROCESS_APPROVED_FLOW_ILLEGAL_STATUS:
    '검토 상태 오류: 상태가 승인 일 때만 완료 처리 작업이 허용됩니다 (데이터가 이미 변경되었을 수 있으므로 데이터를 다시 검색한 후 다시 시도하십시오)', // 审核状态错误：审核状态为通过时才允许完成处理操作（数据可能已发生变化，请重新检索数据后再尝试）
  INVALID_ARGUMENT_PROCESS_APPROVED_FLOW_ILLEGAL_PROCESSED:
    '처리 상태 오류: 처리 상태가 미처리 상태 일 때만 완료 처리 작업이 허용됩니다 (데이터가 이미 변경되었을 수 있으므로 데이터를 다시 검색한 후 다시 시도하십시오)', // 处理状态错误：处理状态为未处理时才允许完成处理操作（数据可能已发生变化，请重新检索数据后再尝试）
  INVALID_ARGUMENT_PROCESS_REJECT_FLOW_ILLEGAL_STATUS:
    '검토 상태 오류: 상태가 반려 일 때만 완료 처리 작업이 허용됩니다 (데이터가 이미 변경되었을 수 있으므로 데이터를 다시 검색한 후 다시 시도하십시오)', // 审核状态错误：审核状态为驳回时才允许完成处理操作（数据可能已发生变化，请重新检索数据后再尝试）
  INVALID_ARGUMENT_PROCESS_ILLEGAL_STATUS: '상태 오류', // 状态错误
  // 5.5 KRAMPUS API相关
  INVALID_ARGUMENT_KRAMPUS_API_DUP_LOGIN: '거래 시스템 사용자 이름이 이미 존재합니다', // 交易系统用户名已存在
  INVALID_ARGUMENT_KRAMPUS_API_WRONG_KEY_OR_SECRET: '거래 시스템 사용자 이름/비밀번호가 잘못되었습니다', // 交易系统用户名/密码错误
  INVALID_ARGUMENT_KRAMPUS_API_LOGIN_FAILED: '거래 시스템 로그인에 실패했습니다', // 交易系统登录失败
  INVALID_ARGUMENT_DEMO_KRAMPUS_API_DUP_LOGIN: '데모 거래 시스템 사용자 이름이 이미 존재합니다', // 模拟交易系统用户名已存在
  INVALID_ARGUMENT_DEMO_KRAMPUS_API_WRONG_KEY_OR_SECRET: '데모 거래 시스템 사용자 이름/비밀번호가 잘못되었습니다', // 模拟交易系统用户名/密码错误
  INVALID_ARGUMENT_DEMO_KRAMPUS_API_LOGIN_FAILED: '데모 거래 시스템 로그인에 실패했습니다', // 模拟交易系统登录失败
  INVALID_ARGUMENT_KRAMPUS_API_SYNC_IT_FAILED:
    '기관 정보 동기화 실패, {itId} ID의 거래 시스템 기관을 찾을 수 없습니다. 권한을 확인하십시오', // 同步机构信息失败，未找到交易系统ID为{itId}的机构，请查看权限
  INVALID_ARGUMENT_KRAMPUS_API_INVOKE_ERROR: '거래 시스템 호출에 실패했습니다', // 交易系统调用失败
  INVALID_ARGUMENT_KRAMPUS_API_INSUFFICIENT_FUNDS: '계정 잔액이 부족합니다', // 账户余额不足
  INVALID_ARGUMENT_KRAMPUS_API_PASSWORD_IS_EMPTY: '비밀번호가 비어 있습니다. 먼저 비밀번호를 설정하십시오', // 密码为空，请先设置密码
  INVALID_ARGUMENT_KRAMPUS_API_TOKEN_FAILED: '로그인이 만료되었습니다. 다시 로그인하십시오', // 登录过期，请重新登录
  // token相关
  INVALID_ARGUMENT_INVALID_ISSUER_FORMAT: '발행자 형식이 유효하지 않습니다', // Issuer格式无效
  INVALID_ARGUMENT_MISSING_LOGIN_CODE: '로그인 코드가 누락되었습니다', // 缺少登录代码
  INVALID_ARGUMENT_CUSTOMER_NOT_FOUND: '고객을 찾을 수 없습니다', // 找不到客户
  INVALID_ARGUMENT_MISSING_PASSWORD_TIME_CLAIM: '비밀번호 시간 클레임이 누락되었습니다', // 缺少密码时间声明
  INVALID_ARGUMENT_PASSWORD_TIME_MISMATCH: '비밀번호 시간이 일치하지 않습니다', // 密码时间不匹配
  INVALID_ARGUMENT_TOKEN_EXPIRED: '토큰이 만료되었습니다', // 令牌已过期
  // 5.6 METHOD 相关
  INVALID_ARGUMENT_METHOD_BANK_USDT_INVALID: '은행 입금 통화로 USDT를 선택할 수 없습니다', // 银行的充值货币不能是USDT
  INVALID_ARGUMENT_METHOD_BANK_BANK_CAN_NOT_NULL: '은행을 선택하십시오', // 请选择银行
  INVALID_ARGUMENT_METHOD_BANK_ACCOUNT_NAME_CAN_NOT_EMPTY: '은행 계좌 이름은 비워 둘 수 없습니다', // 银行帐号名称不可以为空
  INVALID_ARGUMENT_METHOD_BANK_ACCOUNT_NUMBER_CAN_NOT_EMPTY: '은행 계좌 번호는 비워 둘 수 없습니다', // 银行帐号号码不可以为空
  INVALID_ARGUMENT_METHOD_USDT_USDT_ONLY: 'USDT 입금 통화는 반드시 USDT여야 합니다', // USDT的充值货币必须是USDT
  INVALID_ARGUMENT_METHOD_USDT_AT_LEAST_ONE_IS_REQUIRED: '주소와 QR 코드 중 하나를 적어도 하나는 입력해야 합니다', // 地址和二维码至少需要填写一个
  INVALID_ARGUMENT_METHOD_USDT_CRYPTO_NETWORK_REQUIRED: 'USDT 입금 네트워크를 입력해야 합니다', // USDT的充值网络必须填写
  INVALID_ARGUMENT_METHOD_WECHAT_CNY_ONLY: 'WeChat 입금 통화는 반드시 인민폐여야 합니다', // 微信的充值货币必须是人民币
  INVALID_ARGUMENT_METHOD_REQUIRE_QR_CODE: '현재 입금 방식은 반드시 QR 코드를 업로드해야 합니다', // 当前充值方式必须上传二维码
  // 5.7 入出金相关
  INVALID_ARGUMENT_IT_TRANSFER_CONFIG_ERROR: '채널 구성 오류', // 通道配置错误
  INVALID_ARGUMENT_IT_TRANSFER_CAN_NOT_BE_NULL: '기관 송금은 비워 둘 수 없습니다', // 机构转账不可为空
  INVALID_ARGUMENT_IT_TRANSFER_AMOUNT_CAN_NOT_BE_NULL: '기관 송금 금액은 비워 둘 수 없습니다', // 机构转账金额不可为空
  INVALID_ARGUMENT_IT_TRANSFER_RECEIVE_CAN_NOT_BE_NULL: '기관 송금 계정은 비워 둘 수 없습니다', // 机构转账帐号不可为空
  INVALID_ARGUMENT_DEPOSIT_AMOUNT_TRANSFER_AMOUNT_NOT_MATCH: '입금 금액이 송금 금액과 일치하지 않습니다', // 存入金额与转账金额不匹配
  INVALID_ARGUMENT_PAYMENT_SAME_TYPE_PAYMENT_CHANNEL_ONLY_ONE: '동일 유형의 지불 채널은 하나만 선택할 수 있습니다', // 相同类型的支付通道只能选择一个
  INVALID_ARGUMENT_DUPLICATE_PAYMENT_CHANNEL_TYPE: '동일 유형의 지불 게이트웨이는 하나만 선택할 수 있습니다', // 相同类型的支付网关只能选择一个
  INVALID_ARGUMENT_PAYMENT_INVOKE_ERROR: '지불 API 인터페이스 호출 실패', // 调用支付API接口失败
  INVALID_ARGUMENT_PAYMENT_INVOKE_PARAM_ERROR: '지불 매개변수 오류', // 调用支付参数错误
  INVALID_ARGUMENT_TRANSACTION_AMOUNT: '입출금 한도를 충족시키지 못합니다', // 入出金不满足限定额度
  INVALID_ARGUMENT_CLOSE_ACCOUNT_ERROR: '계정 해지 실패, 포지션을 비워야하며 자금이 0이어야 합니다', // 注销账户失败，必须清空持仓并且资金为零
  INVALID_ARGUMENT_CONFIG_PIX_NOT_NULL: 'PIX 정보를 비울 수 없습니다. 은행 카드 관리 페이지에서 PIX 정보를 업데이트해 주세요.',
  INVALID_ARGUMENT_CONFIG_IFSC_NOT_NULL: 'IFSC 정보를 비울 수 없습니다. 은행 카드 관리 페이지에서 IFSC 정보를 업데이트해 주세요.',
  // 6. 操作校验
  UNSUPPORTED_OPERATION_NO_IT_RECEIVE_FOUND: '해당 기관은 이 통화의 입금을 지원하지 않습니다', // 该机构不支持该货币的入金
  // 7. 邮箱验证
  THIRD_PARTY_AUTH_USER_CANNOT_RESET_PASSWORD: '사설 인증 계정은 비밀번호를 재설정할 수 없습니다', // 三方认证계정은 비밀번호를 재설정할 수 없습니다
  INVALID_THIRD_PARTY_ACCOUNT_UNBINDING_FAILED: '사설 계정 바인딩 해제 실패', // 三方账号解除绑定失败
  THIRD_PARTY_AUTH_USER_CANNOT_ACTIVE_EMAIL: '사설 인증 계정은 계정을 활성화할 필요가 없습니다', // 三方认证계정은 계정을 활성화할 필요가 없습니다
  INVALID_ACCOUNT_ALREADY_EXISTS_AND_LOCKED: '이 계정은 이미 존재하며 잠겨 있습니다', // 该账户已存在且被锁定
  INVALID_EMAIL_CHECK_INVALID_USER: '잘못된 사용자', // 无效用户
  INVALID_EMAIL_CHECK_USER_NOT_EXIST: '사용자가 존재하지 않습니다', // 用户不存在
  INVALID_EMAIL_CHECK_EMAIL_VERIFIED: '이메일이 이미 확인되었습니다', // 邮箱已经验证
  INVALID_EMAIL_CHECK_EMAIL_NOT_VERIFIED: '이메일이 확인되지 않았습니다', // 邮箱未经验证
  INVALID_EMAIL_CHECK_INVALID_REQUEST_PARAMETERS: '작업 실패, 요청 시간이 초과되었습니다', // 操作失败,请求超时
  INVALID_EMAIL_CHECK_REPEATED_REQUEST: '반복된 요청, 나중에 다시 시도하십시오', // 重复请求,请稍后尝试
  INVALID_ARGUMENT_INVALID_PROVIDERTYPE: '잘못된 제공자 로그인 유형', // 无效的三方登陆类型
  INVALID_ARGUMENT_ORIGINAL_PASSWORD_MISMATCH: '비밀번호 수정, 원래 비밀번호가 일치하지 않습니다', // 修改密码,原始密码不匹配
  INVALID_ARGUMENT_NEW_PASSWORD_SAME_AS_OLD: '새 비밀번호는 이전 비밀번호와 동일할 수 없습니다', // 新密码不能和旧密码一样
  INVALID_ARGUMENT_EXCLUSIVE_AGENT_LINK: '등록할 수 없음,이 링크는 전용 대리인에 속하며 여러 번의 등록이 금지되어 있습니다', // 无法注册，该链接属于专属代理,禁止多次注册
  INVALID_ARGUMENT_DUPLICATE_WITHDRAWAL: '주문을 철회하고 현금을 다시 인출하거나 주문이 검토될 때까지 기다렸다가 다시 시작하세요.',
  // 注册
  REGISTER_DUP_USERNAME: '이 사용자 이름은 이미 등록되어 있습니다', // 该用户名已被注册
  REGISTER_DUP_MOBILE: '이 휴대전화 번호는 이미 등록되어 있습니다', // 该手机号已被注册
  USERNAME_WRONG_FORMAT: '사용자 이름 형식이 잘못되었습니다', // 用户名格式错误
  MOBILE_WRONG_FORMAT: '휴대전화 번호 형식이 잘못되었습니다', // 手机号格式错误
  ID_CARD_ID_WRONG_FORMAT: '신분증 번호 형식이 잘못되었습니다', // 身份证号码格式错误

  // 登录
  LOGIN_FAILED: '로그인 실패, 사용자 이름 또는 비밀번호가 잘못되었습니다', // 登录失败，用户名或密码有误
  LOGIN_NOT_ENABLED: '계정이 비활성화되었습니다', // 帐号已被禁用
  LOGIN_LOCKED: '계정이 잠겼습니다', // 帐号已被锁定
  // 密码
  PASSWORD_WRONG: '비밀번호 입력이 잘못되었습니다', // 密码输入错误
  PASSWORD_WRONG_FORMAT: '비밀번호는 6~16 자여야하며 공백을 포함할 수 없습니다', // 密码必须为6~16位字符，并且不能包含空格
  PASSWORD_WRONG_TIME_LEFT: '비밀번호 입력이 잘못되었습니다. {timeLeft}번 기회가 남아 있습니다', // 密码输入错误，还剩{timeLeft}次机会
  PASSWORD_CONFIRM_NOT_MATCH: '비밀번호 확인이 일치하지 않습니다', // 确认密码不匹配
  PASSWORD_WRONG_AND_LOCK: '연속 {failedAttempt}번 비밀번호 입력이 잘못되었으며 계정이 잠겼습니다', // 连续{failedAttempt}次密码输入错误，帐号被锁定
  PASSWORD_NULL: '비밀번호를 입력해주세요', // 密码不能为空
  CONFIRM_PASSWORD_NOT_MATCH: '비밀번호 확인이 일치하지 않습니다', // 确认密码不匹配
  // 权限
  PERMISSION_DENY: '접근 권한이 없습니다', // 你没有访问权限
  // Jwt Token
  JWT_INVALID_TOKEN: '로그인이 만료되었습니다. 다시 로그인해주세요', // 登录过期，请重新登录
  JWT_VERSION_NOT_MATCHED: '버전이 일치하지 않습니다', // 版本不匹配
  // 手机验证码
  SMS_VERIFY_CODE_NOT_MATCH: '인증 코드가 일치하지 않습니다', // 验证码不匹配
  CAPTCHA_VERIFY_CODE_NOT_MATCH: '인증 코드가 일치하지 않습니다', // 验证码不匹配
  // 参数校验

  INVALID_ARGUMENT: '잘못된 매개 변수', // 参数错误
  INVALID_ARGUMENT_NULL_POINT: '잘못된 매개 변수: 매개 변수를 비울 수 없습니다', // 参数错误：参数不能为空
  // 其他
  DATA_NOT_FOUND: '데이터를 찾을 수 없습니다', // 数据未找到
  STALE_VERSION: '데이터가 변경되었습니다. 다시 시도해 주십시오', // 数据改变，请刷新再试
  INVALID_STATE: '잘못된 상태, 데이터가 이미 변경되었을 수 있습니다', // 无效状态，数据可能已发生改变
  INVALID_VALUE: '매개 변수 내용 오류', // 参数内容错误
  INVALID_FORMAT: '매개 변수 형식 오류', // 参数格式错误
  INTERNAL_ERROR: '내부 오류, 관리자에게 문의하십시오', // 内部错误，请联系管理员
  MULTI_ARGS_TEST: 'arg1 {arg1}，arg2 {arg2}，arg3 {arg3}', // arg1 {arg1}，arg2 {arg2}，arg3 {arg3}
  INVALID_ARGUMENT_NOT_BLANK: '빈 공간이어서는 안됩니다', // 不能是空白字符

  // 第三方
  access_denied: '접근 거부됨', // 访问拒绝
  invalid_token_response: '유효하지 않은 토큰', // 无效的令牌
  authorization_request_not_found: '인증 요청을 찾을 수 없습니다', // 未找到认证请求

  INVALID_ARGUMENT_CUSTOMER_PHONE_FORMAT: '사용자는 전화번호여야 합니다.',
  INVALID_EMAIL_CHECK_CONTACT_VERIFIED: '계정이 확인되었습니다.',
  INVALID_EMAIL_CHECK_CONTACT_NOT_VERIFIED: '계정이 확인되지 않았습니다.',
  INVALID_ARGUMENT_SMS_CODE_TIMEOUT: '인증 코드가 만료되었습니다.',
  INVALID_ARGUMENT_SMS_CODE_ERROR: '잘못된 인증 코드입니다.',
  INVALID_ARGUMENT_SMS_RATE_LIMIT: 'SMS 전송 빈도를 초과했습니다. 잠시 후 다시 시도하십시오.',
};
